<template>
  <!-- <div class="row"> -->
  <draggable
    v-model="items_"
    handle=".column-handle"
    tag="div"
    group="column"
    @change="columns_changed"
    class="row"
    @input="reorder_columns()"
  >
    <sb-col
      v-for="(item, k) in items_"
      @update_column="update_column($event, k)"
      @remove_element="remove_element($event, k)"
      @remove_column="remove_column(k)"
      @add_element="add_element(k)"
      @added="element_added($event, k)"
      @removed="element_removed($event, k)"
      @moved="element_moved($event, k)"
      @element_change="element_change($event, k)"
      :key="'sbcol-' + row_index + '-' + k"
      :items="item.items"
      :classes="item.classes"
      :id="item.id"
      :col_index="row_index.toString() + k.toString()"
    ></sb-col>
    <div class="col-12 my-3" slot="footer">
    <button class="btn btn-sm btn-light" @click="add_column">Add column</button>
    </div>
  </draggable>
  <!-- </div> -->
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      items_: [],
    };
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    row_index: {
      type: String,
      default: "0",
    },
  },
  methods: {
    columns_changed(payload) {
      if (payload.added) this.$emit("column_added", payload.added);
      if (payload.removed) this.$emit("column_removed", payload.removed);
      if (payload.moved) this.$emit("column_moved", payload.moved);
    },
    update_column(payload, index) {
      this.$emit("update_column", {
        index: index,
        type: payload.type,
        value: payload.value,
      });
    },
    reorder_columns() {
      this.$emit("reorder_columns", { value: this.items_ });
    },
    remove_element(payload, index) {
      this.$emit("remove_element", { index: index, element_index: payload });
    },
    add_column() {
      this.$emit("add_column");
    },
    remove_column(index) {
      this.$emit("remove_column", index);
    },
    add_element(index) {
      console.log(index)
      this.$emit("add_element", index);
    },
    element_added(payload, index) {
      this.$emit("element_added", {
        index: index,
        element_index: payload.newIndex,
        element: payload.element,
      });
    },
    element_removed(payload, index) {
      this.$emit("element_removed", {
        index: index,
        element_index: payload.oldIndex,
        element: payload.element,
      });
    },
    element_moved(payload, index) {
      this.$emit("element_moved", {
        index: index,
        element_index: payload.newIndex,
        element_old_index: payload.oldIndex,
        element: payload.element,
      });
    },
    element_change(payload, index) {
      console.log(payload);
      this.$emit("element_cahnge", {
        index: index,
        element_index: payload.index,
        element: payload.element,
      });
    },
  },
  mounted() {
    this.items_ = this.items;
  },
};
</script>
